import { render, staticRenderFns } from "./Curricula.vue?vue&type=template&id=a5db34a6&scoped=true"
import script from "@/views/Curricula/Curricula.ts?vue&type=script&lang=ts&external"
export * from "@/views/Curricula/Curricula.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Curricula/Curricula.scss?vue&type=style&index=0&id=a5db34a6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5db34a6",
  null
  
)

export default component.exports